import { render, staticRenderFns } from "./ReservasGenericas.vue?vue&type=template&id=1dc7416b&scoped=true"
import script from "./ReservasGenericas.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservasGenericas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReservasGenericas.vue?vue&type=style&index=0&id=1dc7416b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc7416b",
  null
  
)

export default component.exports